import ApiService from '@/core/services/ApiService';
import { Storage } from '@/core/helpers/Storage';
import { Encryption } from '@/core/helpers/Encryption';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Endpoints } from '@/api/ApiEndpoints';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';
import Messages from '@/core/helpers/Messages';
import { Names } from '@/core/config/enums/SitePaths';
export interface User {
	firstName: string;
	lastName: string;
	userName: string;
	email: string;
	storeID: string;
	clientID: string;
	apiToken: string;
	refreshToken: string;
}

@Module
export default class AuthModule extends VuexModule {
	user = {} as User;

	/**
	 * Get current user object
	 * @returns User
	 */
	get currentUser(): User {
		return this.user;
	}

	/**
	 * Verify user authentication
	 * @returns boolean
	 */
	get isUserAuthenticated(): boolean {
		const apiTokenFromStorage = Storage.get('apiToken');
		if (apiTokenFromStorage) {
			return true;
		} else {
			return false;
		}
	}

	/**
	 * Get authentification errors
	 * @returns array
	 */
	

	@Mutation
	[Mutations.SET_AUTH](loginResponse) {
		this.user.firstName = loginResponse.user.firstName;
		Storage.set('firstName', loginResponse.user.firstName, 864000);
		this.user.lastName = loginResponse.user.lastName;
		Storage.set('lastName', loginResponse.user.lastName, 864000);
		this.user.userName = loginResponse.user.userName;
		Storage.set('userName', loginResponse.user.userName, 864000);
		this.user.email = loginResponse.user.email;
		Storage.set('email', loginResponse.user.email, 864000);
		this.user.storeID = loginResponse.storeID;
		Storage.set('storeID', loginResponse.storeID, 864000);
		this.user.clientID = loginResponse.clientID;
		Storage.set('clientID', loginResponse.clientID, 864000);

		if (loginResponse.user.roles) {
			loginResponse.user.roles.forEach((role) => {
				Storage.set('role', Encryption.encrypt(role.name), 864000);
				if (role.canAccessAllOperations) {
					Storage.set('canAccessAllOperations', '1', 864000);
				}
				role.roleClaims.forEach((claim) => {
					Storage.set(claim.name, Encryption.encrypt(claim.name), 864000);
				});
			});
		}
		
		this.user.apiToken = loginResponse.accessToken;
		Storage.set('apiToken', loginResponse.accessToken, 864000);
		this.user.refreshToken = loginResponse.refreshToken;
		Storage.set('refreshToken', loginResponse.refreshToken, 864000);
	}

	@Mutation
	[Mutations.SET_USER](user) {
		this.user = user;
	}

	@Mutation
	[Mutations.PURGE_AUTH]() {
		Storage.clear();
		this.user = {} as User;
		
	}

	@Action({ rawError: true })
	async [Actions.LOGIN](credentials) {
		const data = await ApiService.post(Endpoints.LOGIN, { ...credentials }) as any

		
		if(data){
			this.context.commit(Mutations.SET_AUTH, data.data);
			if(Object.keys(this.context.rootState.ErrorModule.errors).length == 0){
				Messages.showSuccess("You have successfully logged in!",Names.DASHBOARD);
			}	
		}
	}

	@Action
	[Actions.LOGOUT]() {
		
		this.context.commit(Mutations.PURGE_AUTH);
	}

	@Action
	async [Actions.REGISTER](credentials) {
		const data = await ApiService.post('register', credentials);
		
		this.context.commit(Mutations.SET_AUTH, data);
			
	}

	@Action
	[Actions.FORGOT_PASSWORD](payload) {
		ApiService.post('forgot_password', payload)
		this.context.commit(Mutations.SET_ERROR, {});
		
	}
}
